import { inject } from '@angular/core';

import { HomePageConfig } from '../client-config/client-config.models';
import { HomeResourceService } from './home-resource.service';

export const HomeResolver = () => {
    const resource = inject(HomeResourceService);
    const config = inject(HomePageConfig);
    if (config.isVanillaHomePageEnabled) {
        return {};
    }
    return resource.getInitValues();
};
